import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/posthog";

const CONTACT_EMAIL = "office@vita-dom.org";
const RESERVE_AMOUNT = 10;

export function usePageTracking(sectionId?: string) {
  const location = useLocation();
  const trackedRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    trackEvent("$pageview", { path: location.pathname, section: sectionId });
  }, [location.pathname, sectionId]);

  return { trackEvent, CONTACT_EMAIL, RESERVE_AMOUNT };
}

export function trackSectionView(sectionId: string) {
  trackEvent("section_viewed", { section: sectionId });
}

export function trackCTAClick(ctaId: string, properties?: Record<string, unknown>) {
  trackEvent("cta_clicked", { cta_id: ctaId, ...properties });
}

export function trackPlanSelected(planKey: string, planPrice: string) {
  trackEvent("plan_selected", { plan: planKey, price: planPrice });
}

export function trackReserveClicked(planKey: string) {
  trackEvent("reserve_clicked", { plan: planKey, amount_eur: 10 });
}

export function trackContactClicked(source: string) {
  trackEvent("contact_clicked", { source, email: CONTACT_EMAIL });
}
